import { forwardRef } from 'react'
import clsx from 'clsx'
import { TextareaAutosize } from '@mui/material'

export interface TextAreaProps {
	placeholder?: string
	hasError?: boolean
	minRows: number
	className?: string
	onInput?: (event: React.FormEvent<HTMLTextAreaElement>) => void
	defaultValue?: string
	/** Controlled usage (e.g. RHF Controller) — pass alongside `onChange` instead of `defaultValue`/`onInput` */
	value?: string
	onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
	disabled?: boolean
	maxLength?: number
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
	({ placeholder = '', className, hasError = false, minRows, onInput, defaultValue, ...rest }, ref) => {
		return (
			<div className="relative w-full">
				<TextareaAutosize
					className={clsx(
						'px-4 py-3 border-2 border-translucent-plus-border bg-primary-surface/[0.4] backdrop-blur-lg rounded-lg text-primary-text placeholder-secondary-text placeholder:italic placeholder:font-light block w-full focus:ring-0 focus:border-translucent-plus-border',
						className,
						{
							'!border-secondary-red': !!hasError,
						}
					)}
					minRows={minRows}
					placeholder={placeholder}
					ref={ref}
					onInput={e => {
						onInput?.(e)
					}}
					defaultValue={defaultValue}
					{...rest}
				/>
			</div>
		)
	}
)
